import List from '@utils/list'

const { Search, Table } = List

const search = new Search('ordersupplier.closingorder')
  .placeholder('searchPlaceholder')
  .add('purchaseUnitNo')
  .lib('dateRange').prop(['purchaseDateStart', 'purchaseDateEnd']).mapKey('dateRange1')
  .lib('dateRange').prop(['deliveryDateStart', 'deliveryDateEnd']).br()
  .add('goodsNo')
  .add('goodsName')
  .add('spec')

const table = new Table('ordersupplier.closingorder')
  .add('purchaseNo')
  .add('purchaseDate')
  .add('settleOfficeName')
  .add('purOfficeName')
  .add('employeeName')
  .add('remarksHead')
  .add('seqPhase')
  // .add('seqPhase')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')
  .add('batchPurQty')
  .add('unitPrice')
  .add('expectedArrivalDate')
  // .add('status')
  // .add('closingReason')
  // .add('remarks')
  // .add('dataSource')

export default new List()
  .url('/srmClosingOrder/getSrmClosingOrderPageByParams', process.env.VUE_APP_CONTRACT_API)
  .search(search)
  .table(table)
  .end()
